import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column align-center justify-center ma-6 pt-10",
    },
    [
      _c(VImg, {
        attrs: {
          src: "/static/_v1/pd/pictures/ui-kit/search.svg",
          alt: "Not found",
          width: "150px",
          height: "150px",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-h6 text--text mb-2 text-center" }, [
        _vm._v("\n    Ничего не нашлось\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-body-1 text-secondary--text text-center" },
        [_vm._v("\n    Проверьте, нет ли ошибки в запросе\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }